export const timeslotConstants = {
	KIND_BOOKING: 'booking',
	KIND_LUNCH: 'lunch',
	KIND_MEETING_ROOM: 'meeting_room',
	KIND_TRANSPORT: 'transport',
};
